import BasePage from "./BasePage";

export default BasePage;
